import {
  ForgotPassword,
  SignIn,
  ConfirmSignIn,
  ConfirmSignUp,
  Loading,
  withAuthenticator,
} from 'aws-amplify-react'
import React from 'react'
import { connect } from 'react-redux'
import { Switch, Route, useLocation } from 'react-router-dom'

import { SignUp } from '../components/auth/SignUp'
import { CrewsPage } from '../components/crews/CrewsPage'
import { SchedulerPage } from '../components/scheduler/SchedulerPage'
import { COLORS } from '../constants/colors'
import { getIsManager } from '../modules/organization'
import Main from './main.page'

const theme = {
  a: { color: COLORS.THEME.PRIMARY },
  button: { backgroundColor: COLORS.THEME.SECONDARY, borderRadius: '4px' },
  container: { fontFamily: 'Nunito Sans', fontSize: '16px' },
  input: { fontFamily: 'Nunito Sans', fontSize: '16px' },
  inputLabel: { fontFamily: 'Nunito Sans', fontSize: '16px' },
  sectionHeader: { fontSize: '20px' },
}

const mapStateToProps = (state) => ({
  isManager: getIsManager(state),
})

function AppRoutes({ isManager }) {
  const { pathname } = useLocation()
  // Keep Main always mounted so the map's WebGL context is never destroyed on
  // navigation. Destroying and re-creating a WebGL context between route changes
  // is unreliable (context limit race); display:none preserves the canvas.
  const showMain = !isManager || pathname === '/'

  return (
    <>
      {isManager && (
        <Switch>
          <Route path="/scheduler" component={SchedulerPage} />
          <Route path="/crews" component={CrewsPage} />
        </Switch>
      )}
      <div style={{ display: showMain ? '' : 'none' }}>
        <Main />
      </div>
    </>
  )
}

const ConnectedAppRoutes = connect(mapStateToProps)(AppRoutes)

const AuthenticatorAppRoutes = withAuthenticator(ConnectedAppRoutes, {
  includeGreetings: false,
  authenticatorComponents: [
    <SignIn />,
    <ConfirmSignIn />,
    <SignUp override={'SignUp'} />,
    <ConfirmSignUp />,
    <ForgotPassword />,
    <Loading />,
  ],
  theme,
})

export { AuthenticatorAppRoutes }
